import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  fullHeightContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    boxSizing: 'border-box',
  },
  loadingSpinner: {
    textAlign: "center",
  },
  image: {
    marginTop: 10, 
    marginBottom: 10,
    width:"55%"
  },
}));
